/* eslint-disable init-declarations */

export interface PromiseWithResolvers<T> {
    promise: Promise<T>
    resolve: (value: T | PromiseLike<T>) => void
    reject: (reason?: any) => void
}

export function withResolvers<T = void>(): PromiseWithResolvers<T> {
    let resolve: PromiseWithResolvers<T>['resolve'] | undefined
    let reject: PromiseWithResolvers<T>['reject'] | undefined

    const promise = new Promise<T>((res, rej) => {
        resolve = res
        reject = rej
    })

    return {
        promise,
        resolve: resolve!,
        reject: reject!,
    }
}
